import { MAX_REVIEW_STARS } from '../constants/reviews';

const writeReviewModalDefault = (
  review,
  productId?: string,
  isMultiPackage = false
) => {
  const version = review.productMetadata?.upm?.packageVersion || '';

  const productMetadata = {
    upm: {
      packageVersion: version,
    },
  };

  return {
    productId: productId || '',
    title: '',
    imageUrl: '',
    version,
    ownedDate: '',
    isMultiPackage,
    data: {
      id: review.id,
      rating: review.rating ?? 0,
      title: review.title ?? '',
      body: review.body ?? '',
      productMetadata,
      lastUpdatedAt: review.updatedAt,
    },
  };
};

export const productReviewsDataMapper = (
  review,
  options?: {
    includeWriteReviewModal?: boolean;
    productId?: string;
    isMultiPackage?: boolean;
  }
) => {
  const baseURL = process.env.SITE_URL || 'https://assetstore.unity.com';
  const mappedVersion = review.productMetadata?.upm?.packageVersion || '';

  return {
    id: review.id,
    reviewerInfo: {
      name: review.userProfile?.name ?? '',
      link: `${baseURL}/users/${review.userProfile?.id || ''}`,
      avatarUrl: review.userProfile?.image || '',
      // TODO: Consider exposing additional reviewer profile metadata (e.g., memberSince, reviewCount, helpfulVoteCount) when available from the backend.
    },
    reviewDetails: {
      id: review.id,
      ownedDate: '', // This will be set by the caller when needed
      canSubmitReview: false, // This will be set by the caller when needed
      stars: {
        value: review.rating ?? 0,
        max: MAX_REVIEW_STARS,
      },
      review: review.body ?? '',
      gifted: false,
      version: mappedVersion,
      title: review.title ?? '',
      publishedDate: review.createdAt,
      canReportReview: review.permissions?.canReport ?? false,
      canEdit: review.permissions?.canEdit ?? false,
      canDelete: review.permissions?.canDelete ?? false,
      canReply: false,
      canHelpfulVotes: review.permissions?.canMarkHelpful ?? false,
      reply: undefined,
      isMultiPackage: options?.isMultiPackage ?? false,
      writeReviewModal: writeReviewModalDefault(
        review,
        options?.productId,
        options?.isMultiPackage
      ),
    },
    ...(options?.includeWriteReviewModal && {
      writeReviewModal: writeReviewModalDefault(
        review,
        options?.productId,
        options?.isMultiPackage
      ),
    }),
  };
};
